export default __webpack_public_path__ + "static/media/lb_logo_circle.9ef4ec4d.svg";